import { render, staticRenderFns } from "./FreeCopiesWidget.vue?vue&type=template&id=07065694&scoped=true"
import script from "./FreeCopiesWidget.vue?vue&type=script&lang=js"
export * from "./FreeCopiesWidget.vue?vue&type=script&lang=js"
import style0 from "./FreeCopiesWidget.vue?vue&type=style&index=0&id=07065694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07065694",
  null
  
)

export default component.exports